/**
 * Pharmacy session helpers — tenant/hospital from store rows or session,
 * and actor identity for created_by / cashier / approver fields.
 * Access is decided entirely by permissions from get_logged_in_user_info
 * (see hooks/useInvRole.js) — nothing here reads or checks a role name.
 * Frontend NEVER sends patient_id to pharmacy endpoints.
 */

function sessionValue(key) {
  const value = sessionStorage.getItem(key);
  return value && value !== 'null' && value !== 'undefined' ? value : '';
}

export function getPharmacyActorId() {
  return sessionValue('USER_ACCESS_KEY') || sessionValue('accessKey') || '';
}

export function getPharmacyActorName() {
  return sessionValue('userName') || sessionValue('username') || getPharmacyActorId() || 'Cashier';
}

/** Raw role string from session — informational only (e.g. tagging `approver_role` on a request). */
export function getPharmacyRole() {
  return String(sessionValue('roleType') || sessionValue('ROLE_TYPE') || sessionValue('PHARMACY_ROLE') || '').toUpperCase();
}

export function getPharmacyStoreId() {
  return sessionValue('PHARMACY_STORE_ID') || sessionValue('store') || '';
}

/** Resolve tenant_id + hospital_id from store (preferred) or session fallbacks. */
export function resolvePharmacyScope(store = null, extra = {}) {
  const scope = {};
  if (extra.tenant_id) scope.tenant_id = extra.tenant_id;
  if (extra.hospital_id) scope.hospital_id = extra.hospital_id;
  if (!scope.tenant_id && store?.tenant_id) scope.tenant_id = store.tenant_id;
  if (!scope.hospital_id && store?.hospital_id) scope.hospital_id = store.hospital_id;
  if (!scope.tenant_id) {
    scope.tenant_id = sessionValue('tenant_id') || sessionValue('TENANT_ID') || '';
  }
  if (!scope.hospital_id) {
    scope.hospital_id = sessionValue('hospital_id') || sessionValue('HOSPITAL_ID') || '';
  }
  return scope;
}

/** Merge tenant/hospital into query params for non-create pharmacy endpoints. */
export function withTenant(params = {}, scope = {}) {
  const next = { ...params };
  if (scope.tenant_id) next.tenant_id = scope.tenant_id;
  if (scope.hospital_id) next.hospital_id = scope.hospital_id;
  return next;
}

export function getCashierContext() {
  const id = getPharmacyActorId();
  const name = getPharmacyActorName();
  return {
    cashier_id: id,
    cashier_name: name,
    shift_id: sessionValue('shift_id') || null,
    counter_id: sessionValue('counter_id') || null,
    created_by: id,
  };
}
